import React, { Component } from "react";
import lev from "fast-levenshtein";
import Item from "./Item.js";
import Toc from "./Toc.js";
import Score from "./Score.js";
import PEOPLE from "./data.json";
import correctIcon from "./correct.svg";
import incorrectIcon from "./incorrect.svg";
import "./App.css";

PEOPLE.forEach(function(d, i) {
  d.component = <Toc lines={d.toc} index={i + 1} />;
  d.submitted = false;
  d.correct = null;
});

export default class extends Component {
  state = {
    people: PEOPLE
  };
  submit = (answer, index) => {
    if (!this.state.people[index].submitted) {
      const correct = checkAnswer(answer, this.state.people[index].variations);
      this.setState(
        {
          people: this.state.people.map((person, i) => {
            if (i === index) {
              return Object.assign({}, person, { correct, submitted: true });
            }
            return person;
          })
        },
        () => {
          this.focus(index + 1);
        }
      );
    }
  };
  focus(i) {
    const input =
      this.sections &&
      this.sections[i] &&
      this.sections[i].querySelector("input");

    if (
      input &&
      (!i || isInViewport(input)) &&
      (window.innerWidth || document.documentElement.clientWidth) >= 700
    ) {
      input.focus({ preventScroll: true });
    }
  }
  componentDidMount() {
    this.sections = [...this.container.querySelectorAll("section")];
    this.focus(0);
    window._skipAll = () =>
      this.setState({
        people: this.state.people.map(person =>
          Object.assign({}, person, {
            correct: Math.random() > 0.5,
            submitted: true
          })
        )
      });
  }
  render() {
    const { people } = this.state;
    const numSubmitted = people.filter(d => d.submitted).length;
    const numCorrect = people.filter(d => d.correct).length;
    const completed = numSubmitted === people.length;
    return (
      <main
        className={completed ? "completed" : ""}
        ref={container => (this.container = container)}
      >
        <header className="desktop">
          Name the celebrity based on their Wikipedia table of contents
        </header>
        <header className="mobile">
          Name the person from their Wikipedia sections
        </header>
        {people.map((person, i) => (
          <Item
            {...person}
            key={person.name}
            submit={answer => this.submit(answer, i)}
          />
        ))}
        {numSubmitted > 0 && (
          <Score
            completed={completed}
            numCorrect={numCorrect}
            numSubmitted={numSubmitted}
          />
        )}
        <img src={incorrectIcon} alt="" style={{ display: "none" }} />
        <img src={correctIcon} alt="" style={{ display: "none" }} />
      </main>
    );
  }
}

function checkAnswer(submission, variations) {
  const toCheck = [submission];
  if (submission.includes(",")) {
    toCheck.push(submission.split(",")[0]);
  }
  for (let i = 0; i < toCheck.length; i++) {
    const check = toCheck[i]
      .toLowerCase()
      .replace(/é/g, "e")
      .replace(/á/g, "a")
      .replace(/\W+/g, "");

    for (let j = 0; j < variations.length; j++) {
      let threshold = 1;
      if (variations[j].length > 15) {
        threshold = 3;
      } else if (variations[j].length > 6) {
        threshold = 2;
      }
      if (lev.get(check, variations[j]) <= threshold) {
        return true;
      }

      // Only vowels are wrong
      if (
        check.replace(/[aeiou]+/g, "_") ===
        variations[j].replace(/[aeiou]+/g, "_")
      ) {
        return true;
      }
    }
  }
  return false;
}

function isInViewport(el) {
  const rect = el.getBoundingClientRect();

  return (
    rect.top >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
  );
}
